// TODO: Need to Review; Most likely can be removed after ADS migration is complete

import { Spacer, SpacerProps } from '@qbe/ads-core';
import React from 'react';

export type FormSpacerVariant = 'pagesection' | 'formgroup' | 'input';

export type FormSpacerProps = {
  variant: FormSpacerVariant;
  direction?: SpacerProps['direction'];
};

type MapTypeResult = {
  overrides: SpacerProps['breakpointsOverride'];
  size: SpacerProps['size'];
};

function mapVariant(variant: FormSpacerVariant): MapTypeResult {
  switch (variant) {
    case 'pagesection':
      return { overrides: { mobile: { size: 'md' } }, size: 'md' };
    case 'formgroup':
      return { overrides: { mobile: { size: 'xl' } }, size: 'xl' };
    case 'input':
      return { overrides: { mobile: { size: 'md' } }, size: 'md' };
    default:
      throw new Error('Must provide "variant"');
  }
}

/**
 * @deprecated This component is deprecated and will be removed after ADS migration is complete.
 */
const FormSpacer = ({ variant, direction = 'column' }: FormSpacerProps) => {
  const sizes = mapVariant(variant);
  if (typeof direction === 'undefined') {
    throw Error('Must supply direction prop');
  }
  return <Spacer breakpointsOverride={sizes.overrides} size={sizes.size} direction={direction} />;
};

export default FormSpacer;
